import ProductCarousel from "@/components/ProductCarousel.vue";
import * as themeColors from "@assets/styles/colors.module.scss";
import { builderCta } from "@/helpers/builder-init/index";
import { useBuilderShowIf } from "../composables/builderFieldUtility";
const colors = ["None", ...Object.keys(themeColors)];
const { hasValue, hasValueEqualTo, hasRichText } = useBuilderShowIf();

export const productCarouselInit = {
    component: ProductCarousel,
    name: "ProductCarousel",
    models: ["campaign-content", "category-landing-content", "content-section"],
    inputs: [
        {
            name: "eyebrow",
            type: "object",
            subFields: [
                {
                    name: "text",
                    friendlyName: "Text",
                    type: "string"
                },
                {
                    name: "color",
                    type: "string",
                    enum: colors,
                    showIf: hasValue("text")
                }
            ]
        },
        {
            name: "heading",
            type: "object",
            subFields: [
                {
                    name: "text",
                    friendlyName: "Text",
                    type: "string"
                },
                {
                    name: "color",
                    type: "string",
                    enum: colors,
                    showIf: hasValue("text")
                }
            ]
        },
        {
            name: 'ariaLabel',
            friendlyName: 'Aria Label',
            type: 'string',
            defaultValue: 'Shop Products',
        },
        {
            name: "tag",
            friendlyName: "Merchandising Tag",
            type: "string",
            defaultValue: "",
            onChange: (options) => {
                if (options.get('tag')) {
                    options.set("boostTag", null);
                    options.set("isNew", false);
                    options.set("isBestSellers", false);
                }
            }
        },
        {
            name: 'boostTag',
            friendlyName: 'Personalized Tag',
            type: 'string',
            defaultValue: "",
            onChange: (options) => {
                if (options.get('boostTag')) {
                    options.set("tag", null);
                    options.set("isNew", false);
                    options.set("isBestSellers", false);
                }
            }
        },
        {
            name: 'isNew',
            friendlyName: 'New Arrivals',
            type: 'boolean',
            default: false,
            onChange: (options) => {
                if (options.get('isNew')) {
                    options.set("tag", null);
                    options.set("boostTag", null);
                    options.set("isBestSellers", false);
                }
            }
        },
        {
            name: "isBestSellers",
            friendlyName: "Best Sellers",
            type: "boolean",
            default: false,
            onChange: (options) => {
                if (options.get('isBestSeller')) {
                    options.set("tag", null);
                    options.set("boostTag", null);
                    options.set("isNew", false);
                }
            }
        },
        {
            name: "allowQuickView",
            friendlyName: "Allow Quick View",
            helperText: "Toggle to allow the 'Quick Shop' button to show on the product cards when hovered.",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "autoplay",
            friendlyName: "Autoplay (ms)",
            helperText: "Minimum 1 second (1000ms).",
            type: "number",
            defaultValue: 0
        },
        {
            name: "togglePadding",
            type: "boolean",
            defaultValue: false
        },
        
    ]
};
